const getAuthHeader = password => {
  const pass = `${password}:${password}`;

  return {
      Authorization: `Basic ${btoa(pass)}`
  }
}

export default getAuthHeader;